import { Link } from 'react-router-dom';

const datasets = ["Locators", "Screws"];

const Datasets = () => {
    return (
        <div className="datasets">
            <h1>Datasets</h1>
            <div className="dataset-cards">
                {datasets.map(dataset => (
                    <div key={dataset} className="dataset-card">
                        <Link to={`/dataset/${dataset.toLowerCase()}/1`}>
                            <h2>{dataset}</h2>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};


export default Datasets;
